import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import { useTheme } from '../context/ThemeContext';
import AboutUsBg from '../assets/images/header-backgrounds/background3.png';
import familyPic from '../assets/images/familypic.png';
import HeroHeader from '../components/HeroHeader';
import { Section } from '../components/styled/CommonStyles';

export default function AboutUs() {
  const { currentTheme } = useTheme();

  return (
    <>
      <HeroHeader 
        title="About Hawkins Carpet Cleaning - Owensboro's Trusted Carpet Cleaning Experts" 
        backgroundImage={AboutUsBg}
      />

      <Section theme={currentTheme}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src={familyPic}
                  alt="Hawkins Family - Professional Carpet Cleaners in Owensboro, KY"
                  style={{ 
                    maxWidth: '100%', 
                    borderRadius: '12px', 
                    boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
                    width: '750px'
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography 
                variant="h1" 
                sx={{ 
                  color: 'primary.main',
                  fontWeight: 'bold', 
                  mb: 2, 
                  fontSize: '2.5rem'
                }}
              >
                Your Local Carpet Cleaning Specialists in Owensboro, KY
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  lineHeight: 1.7, 
                  fontSize: '1.15rem',
                  color: 'text.primary'
                }}
              >
                Welcome to Hawkins Carpet Cleaning! My name is Brandon Hawkins, and I am the proud owner of this family-run business. My wife, Michelle, and I have been together since 2011 and tied the knot in 2016. Our family has since grown with the birth of our two wonderful daughters, one in 2018 and the other in 2021.<br /><br />
                Before starting Hawkins Carpet Cleaning in 2019, I spent 10 years working at Glenmore. The decision to start our own business was a leap of faith, driven by a passion for providing top-quality carpet cleaning services while being environmentally conscious. For two years, I balanced my responsibilities at Glenmore with running the business. In 2021, I made the full transition to focus on Hawkins Carpet Cleaning full-time.<br /><br />
                Our commitment to excellence and eco-friendly practices stems from our desire to create a cleaner, healthier environment for our family and yours. Thank you for choosing Hawkins Carpet Cleaning. We look forward to serving you with the same dedication and care that we give to our own home.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Section>
    </>
  );
}